'use es6';

import { connect } from 'react-redux';
import * as formsSelectors from 'ContentData/selectors/forms';
import AddField from './AddField';
const mapStateToProps = (state, props) => {
  const getContactPropertiesAsOptions = formsSelectors.makeGetContactPropertiesAsOptions(props.formDefinition);
  return {
    propertyOptions: getContactPropertiesAsOptions(state, props)
  };
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(AddField);